import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putOtherDetails = async ({ id, accessNotes, specialNotes }: JsonDataItem) => {
  const { data } = await baseQuery('customer-other-details', {
    type: 'PUT',
    body: {
      customerID: id,
      access_notes: accessNotes,
      special_notes: specialNotes,
    },
  });

  return data.customer;
};
